import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import React from 'react';
import { getClientDetails } from './data/DetailPurchase';
import { getDateDetailsError } from './data/DetailsFailedTransactions';
import { getBasicTransactionDetails } from './data/DetailsHistoryPrepaid';
import { getAdditionalInformationDetails } from './data/DetailsMercadoPago';
import { getRequestDetails } from './data/DetailsNetPay';
import { getAmountDetails } from './data/DetailsOpenPay';
import { getPurchasePayerInformationAiralo } from './data/DetailsPurchaseAiralo';
import { getOrderPurchaseDetails } from './data/DetailsPurchaseOrdersIpb';
import { getOrderDetails } from './data/DetailsSimIpb';
import { payerFieldsSTP } from './data/DetailsSTP';
import { getAdditionalInformationDetailStripe } from './data/DetailsStripe';
import { payerFieldsToku } from './data/DetailsToku';
// import { getAdditionalInformationDetailYuno } from './data/DetailsYuno';

const spanStyle = { fontSize: 15, wordWrap: 'break-word' };
const titleStyle = { color: '#7A3C92' };
const valueStyle = {
  textAlign: 'right',
  marginTop: '8px',
  wordWrap: 'break-word',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

const PayerInfo = ({ orderDetails, title, type }) => {
  let fields = [];

  if (type === 'detailsSTP') {
    fields = payerFieldsSTP(orderDetails);
  } else if (type === 'detailsToku') {
    fields = payerFieldsToku(orderDetails);
  } else if (type === 'detailsNetPay') {
    fields = getRequestDetails(orderDetails);
  } else if (type === 'detailsHistoryPrepaid') {
    fields = getBasicTransactionDetails(orderDetails);
  } else if (type === 'detailsSimIpb') {
    fields = getOrderDetails(orderDetails);
  } else if (type === 'detailPurchase') {
    fields = getClientDetails(orderDetails);
  } else if (type === 'detailsOpenPay') {
    fields = getAmountDetails(orderDetails);
  } else if (type === 'detailsMercadoPago') {
    fields = getAdditionalInformationDetails(orderDetails);
  } else if (type === 'DetailsPurchaseOrdersIpb') {
    fields = getOrderPurchaseDetails(orderDetails);
  } else if (type === 'DetailsFailedTransactions') {
    fields = getDateDetailsError(orderDetails);
  } else if (type === 'detailsStripe') {
    fields = getAdditionalInformationDetailStripe(orderDetails[0]);
    // } else if (type === 'detailsYuno') {
    //   fields = getAdditionalInformationDetailYuno(orderDetails[0]);
  } else if (type === 'AiraloDetails') {
    fields = getPurchasePayerInformationAiralo(orderDetails);
  }

  return (
    <Grid container item size={{ xs: 12 }} direction={'column'}>
      <Grid container className='device-info'>
        <Grid item size={{ xs: 12 }}>
          <span style={titleStyle}>{title}</span>
        </Grid>
        {fields.map((field, index) => (
          <React.Fragment key={index}>
            <Grid item size={{ xs: 6 }}>
              <div>
                <span style={spanStyle}>{field.label}:</span>
              </div>
            </Grid>
            <Grid item size={{ xs: 6 }} style={valueStyle}>
              <div>
                <Typography variant='body1'>{field.value || 'N/A'}</Typography>
              </div>
            </Grid>
          </React.Fragment>
        ))}
      </Grid>
    </Grid>
  );
};

export default PayerInfo;
